let BaseURL, loginURL, routePrefix, BaseCoreURL, BusInternal, mapBaseRL;

/*
  for stag route prefix will be '/buspanel'
*/
const isStaging = typeof window !== undefined && window.location.pathname.includes('buspanel')

if(process.env.REACT_APP_MODE === 'PRODUCTION') {
  loginURL = "https://accounts.paytm.com/oauth2/authorize?client_id=busoperator-panel&scope=paytm&response_type=code&redirect_uri=https://bus.paytm.com/code&theme=web&state=null&isSignup=false#/login";
  BaseURL = "https://travel.paytm.com/bus-operator-dashboard";
  BaseCoreURL = "https://travel.paytm.com/bus";
  BusInternal = 'https://travel.paytm.com/bus';
  routePrefix = "";
  mapBaseRL="https://travel.paytm.com";
} else {
  loginURL = "https://accounts-staging.paytm.in/oauth2/authorize?client_id=busoperator-panel-stg&scope=paytm&response_type=code&redirect_uri=https://travel-dev.paytm.com/buspanel/code&theme=web&state=null&isSignup=false#/login";
  BaseURL = "https://travel-dev.paytm.com/bus-operator-dashboard";
  BaseCoreURL = "https://travel-dev.paytm.com/bus";
  BusInternal = 'https://travel-dev.paytm.com/internal/bus'
  routePrefix = "/buspanel";
  mapBaseRL="https://travel-dev.paytm.com";
}

export { loginURL, routePrefix, BaseCoreURL, BusInternal, BaseURL, isStaging, mapBaseRL }

export default BaseURL
